document.addEventListener('DOMContentLoaded',function(){  
 if( document.querySelectorAll('.PopUpZoomPDP_Images').length > 0 ){
      document.querySelectorAll('[js-zoom-popup] img').forEach((elm)=>{
       elm.addEventListener('click', (evt)=>{
         evt.preventDefault();
         let CurrentPopupChoosed = evt.target.closest('.swiper-slide').getAttribute('mnmg');
         document.querySelectorAll('.ZoomElementmg').forEach((elm)=>{ elm.classList.remove('active') });
         document.querySelector('.XtZoomEntranceWp').querySelector(`[mnmgzoom="${CurrentPopupChoosed}"]`).classList.add('active');
         document.body.classList.add('zoomPopupActive');
       });
      });
      document.querySelector('.CrossZoomExt').addEventListener('click', (e)=>{
        e.preventDefault();
        document.body.classList.remove('zoomPopupActive');
      });
      document.querySelector('[js-leftzoom]').addEventListener('click', (e)=>{
        e.preventDefault();
        var GetCurrentImageElem = document.querySelector('.XtZoomEntranceWp').querySelector('.ZoomElementmg.active').getAttribute('mnmgzoom');
        var MinusCurrentImageElem = parseInt(GetCurrentImageElem) - parseInt(1);      
        document.querySelector('.XtZoomEntranceWp').querySelector('.ZoomElementmg.active').previousElementSibling ? 
        ( 
          document.querySelector('.XtZoomEntranceWp').querySelector(`[mnmgzoom="${MinusCurrentImageElem}"]`).classList.add('active'),
          document.querySelector('.XtZoomEntranceWp').querySelector(`[mnmgzoom="${GetCurrentImageElem}"]`).classList.remove('active')
        )
          :
        ( 
          document.querySelector('.XtZoomEntranceWp').lastElementChild.classList.add('active'),
          document.querySelector('.XtZoomEntranceWp').firstElementChild.classList.remove('active')
        )
      });
      document.querySelector('[js-rightzoom]').addEventListener('click', (e)=>{
        e.preventDefault();
        var GetCurrentImageElem = document.querySelector('.XtZoomEntranceWp').querySelector('.ZoomElementmg.active').getAttribute('mnmgzoom');
        var PlusCurrentImageElem = parseInt(GetCurrentImageElem) + parseInt(1);
        document.querySelector('.XtZoomEntranceWp').querySelector('.ZoomElementmg.active').nextElementSibling ? 
        ( 
          document.querySelector('.XtZoomEntranceWp').querySelector(`[mnmgzoom="${PlusCurrentImageElem}"]`).classList.add('active'),
          document.querySelector('.XtZoomEntranceWp').querySelector(`[mnmgzoom="${GetCurrentImageElem}"]`).classList.remove('active')
        ):
        ( 
          document.querySelector('.XtZoomEntranceWp').firstElementChild.classList.add('active'),
          document.querySelector('.XtZoomEntranceWp').lastElementChild.classList.remove('active')
        )      
      });  
  } 
})